import Metrics from '@ibkr/clientportal.common/src/js/Metrics'

import * as types from '../mutation-types'

function reportWebsocketStatus(status) {
    if (Metrics == undefined) {
        return;
    }
    Metrics.instance().registerDaily({
        'type': 'websocket-support',
        'source': 'Common',
        'value': status
    });
}

const state = {
    /*
     * Flag to denote current trasnport mode
     * undefined value implies transport mode to be used is being identified
     * if true, websopckets are used
     * if false, polling is used
     */
    enableRealtime: undefined,
    showIbot: true
}

const getters = {
    /* Check in order:
     *  - Environment enabled
     *  - state.enableRealtime flag
     */
    realtime: (state, getters, rootState) => {
        if (!process.env.WEBSOCKETS) {
            console.debug('websockets disabled for this environment');
            return false;
        } else {
            return state.enableRealtime;
        }
    }
}

const mutations = {
    [types.SET_ENABLE_REALTIME] : (state, val) => {
        state.enableRealtime = val;
    }
}

const actions = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

